(function () {
  var LINK_TEXT = /do not sell or share my personal information/i;
  var SUPPORT_EMAIL = 'support@teamk9.com';
  var FALLBACK_HREF = 'mailto:' + SUPPORT_EMAIL + '?subject=Do%20Not%20Sell%20or%20Share%20My%20Personal%20Information';

  function hasCustomerPrivacyApi() {
    return window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function';
  }

  function setLinkStatus(link, text) {
    var previous = link.textContent;
    link.textContent = text;
    window.setTimeout(function () {
      link.textContent = previous || 'Do Not Sell or Share My Personal Information';
    }, 3500);
  }

  function requestOptOut(link) {
    if (!hasCustomerPrivacyApi()) {
      window.location.href = FALLBACK_HREF;
      return;
    }

    window.Shopify.customerPrivacy.setTrackingConsent(
      { sale_of_data: false, analytics: false, marketing: false },
      function () {
        setLinkStatus(link, 'Privacy choice saved');
      }
    );
  }

  function wirePrivacyLinks() {
    Array.prototype.slice.call(document.querySelectorAll('a')).forEach(function (link) {
      if (!LINK_TEXT.test(link.textContent || '') || link.dataset.tk9PrivacyOptOut === 'true') return;
      link.dataset.tk9PrivacyOptOut = 'true';
      link.href = '#privacy-opt-out';
      link.setAttribute('role', 'button');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        requestOptOut(link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wirePrivacyLinks, { once: true });
  } else {
    wirePrivacyLinks();
  }

  // tk9-fix 2026-06-19: bounded — was a PERPETUAL full-page MutationObserver (observer-storm
  // contributor that helped freeze the page). The privacy link lives in the footer (present at
  // load); wire once + a few bounded passes for late mounts, then disconnect so it never scans
  // the whole document forever.
  if (window.MutationObserver) {
    var privacyObserver = new MutationObserver(wirePrivacyLinks);
    privacyObserver.observe(document.documentElement, { childList: true, subtree: true });
    [800, 2500, 6000].forEach(function (d) { window.setTimeout(wirePrivacyLinks, d); });
    window.setTimeout(function () { privacyObserver.disconnect(); }, 8000);
  }
})();

(function () {
  var companyId = 'NESWxx';
  var existingScript = document.querySelector('script[src*="static.klaviyo.com/onsite/js"][src*="company_id=' + companyId + '"]');
  if (existingScript || window.__klKey === companyId) return;

  window._klOnsite = window._klOnsite || [];
  if (!window.klaviyo) {
    try {
      window.klaviyo = new Proxy({}, {
        get: function (_, method) {
          if (method === 'push') {
            return function () {
              window._klOnsite.push.apply(window._klOnsite, arguments);
            };
          }

          return function () {
            var args = Array.prototype.slice.call(arguments);
            var callback = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;
            return new Promise(function (resolve) {
              window._klOnsite.push([method].concat(args, [function (result) {
                if (callback) callback(result);
                resolve(result);
              }]));
            });
          };
        }
      });
    } catch (error) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = function () {
        window._klOnsite.push.apply(window._klOnsite, arguments);
      };
    }
  }

  var script = document.createElement('script');
  script.async = true;
  script.src = 'https://static.klaviyo.com/onsite/js/' + companyId + '/klaviyo.js?company_id=' + companyId;
  document.head.appendChild(script);
})();
